"use client";

import { cn } from "@/lib/utils";
import { VybeAgentMark } from "@/components/desktop/agent/VybeAgentMark";
import { useAgentChat } from "./AgentChatProvider";

interface AgentFabProps {
  onOpen: () => void;
  /** Tuck the FAB against the left edge — the chart tab owns the bottom-right
   * corner (price axis, pending-order pill, market-depth ladder). */
  dodgeChart?: boolean;
}

export function AgentFab({ onOpen, dodgeChart = false }: AgentFabProps) {
  const { status } = useAgentChat();
  const busy = status === "streaming" || status === "submitted";

  return (
    <button
      type="button"
      onClick={onOpen}
      className={cn(
        "fixed z-40 flex items-center justify-center rounded-full border border-border bg-background shadow-lg transition-transform active:scale-95",
        dodgeChart ? "left-3 h-11 w-11 opacity-80" : "right-4 h-14 w-14",
        busy && "animate-pulse ring-2 ring-primary/40",
      )}
      style={{
        bottom: "calc(3.75rem + env(safe-area-inset-bottom, 0px))",
      }}
      title="Open Vybe Agent"
      aria-label="Open Vybe Agent"
    >
      <VybeAgentMark size={24} tone="primary" thinking={busy} />
    </button>
  );
}
